export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Finds",
  "nav.guides": "Guides",
  "nav.review": "Review",
  "nav.shipping": "Versand",
  "nav.comparisons": "Vergleiche",
  "nav.safety": "Sicherheit",
  "nav.blog": "Blog",
  "nav.cta": "Spreadsheet erkunden",
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufs-Guide",

  "hero.h1": "CSSBuy Spreadsheet",
  "hero.subtitle": "Finden Sie die besten Produkte und Ressourcen von CSSBuy an einem Ort. Erkunden Sie organisierte Spreadsheets, Produktfunde, Verkäufer-Guides, QC-Informationen, Versanddetails und aktualisierte Ressourcen, um Ihr Einkaufen zu erleichtern.",
  "hero.cta.primary": "CSSBuy Spreadsheet erkunden",
  "hero.cta.secondary": "CSSBuy Finds ansehen",
  "hero.trust1": "Organisierte Produktlisten",
  "hero.trust2": "Anfänger-Guides",
  "hero.trust3": "Versandinformationen",
  "hero.trust4": "QC-Guides",
  "hero.trust5": "Verkäufer-Ressourcen",
  "hero.trust6": "Aktualisierter Inhalt",

  "categories.title": "Produkte nach Kategorie finden",
  "categories.subtitle": "Stöbern Sie durch unsere kuratierten Kategorien und entdecken Sie die besten Funde bei CSSBuy.",
  "categories.cta": "Alle Kategorien erkunden",

  "cat.shoes": "Schuhe",
  "cat.hoodies": "Hoodies / Pullover",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jacken",
  "cat.pants": "Hosen / Shorts",
  "cat.headwear": "Kopfbedeckung",
  "cat.sets": "Sets",
  "cat.underwear": "Unterwäsche",
  "cat.jersey": "Trikots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Taschen",
  "cat.belts": "Gürtel",
  "cat.perfumes": "Parfums",
  "cat.other": "Sonstiges",

  "featured.spreadsheet.title": "Aktualisierte CSSBuy Spreadsheet",
  "featured.spreadsheet.desc": "Finden Sie Produkte, Kategorien und nützliche Informationen in einer CSSBuy Spreadsheet, die einfach zu durchsuchen und vergleichen ist.",
  "featured.spreadsheet.cta": "Vollständige Spreadsheet ansehen",

  "featured.review.title": "CSSBuy Review",
  "featured.review.desc": "Möchten Sie besser verstehen, wie CSSBuy funktioniert? Lesen Sie unseren Guide zu Funktionen, Vorteilen, Einschränkungen, Versand, Lagerung und wichtigen Punkten vor dem Kauf.",
  "featured.review.cta": "CSSBuy Review lesen",

  "featured.shipping.title": "CSSBuy Shipping Cost",
  "featured.shipping.desc": "Die Versandkosten können je nach Ziel, Gewicht, Volumen, Spedition und gewählter Methode variieren. Sehen Sie sich unseren vollständigen Guide an.",
  "featured.shipping.cta": "Versandkosten-Guide ansehen",

  "featured.coupon.title": "CSSBuy Coupon & Discount Code",
  "featured.coupon.desc": "Informieren Sie sich über Coupons, Aktionen und verfügbare Rabattcodes. Überprüfen Sie immer Gültigkeit und Bedingungen.",
  "featured.coupon.cta": "Angebote ansehen",

  "featured.warehouse.title": "CSSBuy Warehouse",
  "featured.warehouse.desc": "Verstehen Sie, wie Lagerung, QC, Bestellungen und Versandvorbereitung funktionieren.",
  "featured.warehouse.cta": "Warehouse-Guide ansehen",

  "featured.safety.title": "Sicherer Einkaufen",
  "featured.safety.desc": "Überprüfen Sie Links, Verkäufer, Produkte, Zahlungen und Versandbedingungen vor dem Kauf.",
  "featured.safety.cta": "Sicherheits-Guide lesen",

  "articles.title": "Weitere Einkaufs-Guides",
  "articles.subtitle": "Entdecken Sie unsere Bibliothek mit ausführlichen CSSBuy-Guides für jeden Schritt Ihrer Einkaufsreise.",
  "articles.readMore": "Guide lesen",

  "faq.title": "Häufig gestellte Fragen",
  "faq.q1": "Was ist CSSBuy Spreadsheet?",
  "faq.a1": "CSSBuy Spreadsheet ist eine organisierte Sammlung von Produktfunden, Verkäuferinformationen und Einkaufsressourcen, die Ihnen helfen, CSSBuy effizienter zu navigieren. Sie enthält kuratierte Produktlisten, Kategoriefilter und aktualisierte Informationen, um Ihr Einkaufserlebnis zu verbessern.",
  "faq.q2": "Wie verwende ich CSSBuy Spreadsheet?",
  "faq.a2": "Sie können die Spreadsheet nach Kategorie durchsuchen, nach bestimmten Produkten suchen, Verkäuferbewertungen prüfen und Optionen vergleichen. Jeder Eintrag enthält Produktdetails, Verkäuferinformationen und direkte Kauflinks. Wir empfehlen, alle Informationen vor dem Kauf zu verifizieren.",
  "faq.q3": "Ist CSSBuy legitim?",
  "faq.a3": "CSSBuy ist ein bekannter Einkaufsagent, der seit mehreren Jahren aktiv ist. Wie bei jeder Online-Shopping-Plattform ist es jedoch wichtig, Verkäufer zu verifizieren, QC-Fotos zu prüfen und Versandrichtlinien zu verstehen, bevor Sie Käufe tätigen. Diese Website bietet unabhängige Guides für sicheres Einkaufen.",
  "faq.q4": "Ist CSSBuy sicher?",
  "faq.a4": "Sicherheit hängt davon ab, wie Sie die Plattform nutzen. Überprüfen Sie immer den Ruf des Verkäufers, prüfen Sie QC-Fotos (Qualitätskontrolle) vor dem Versand, verwenden Sie sichere Zahlungsmethoden und verstehen Sie die Rückgaberichtlinie. Unser Sicherheits-Guide bietet detaillierte Tipps für sicheres Einkaufen.",
  "faq.q5": "Wie viel kostet der CSSBuy-Versand?",
  "faq.a5": "Versandkosten variieren je nach Zielland, Paketgewicht, Abmessungen, Spedition und gewählter Methode. CSSBuy bietet mehrere Versandlinien mit verschiedenen Geschwindigkeits- und Kostenoptionen. Sehen Sie sich unseren Versandkosten-Guide für detaillierte Aufschlüsselungen an.",
  "faq.q6": "Bietet CSSBuy Coupons an?",
  "faq.a6": "CSSBuy bietet gelegentlich Coupons und Aktionscodes an. Verfügbarkeit und Bedingungen ändern sich im Laufe der Zeit. Überprüfen Sie aktuelle Angebote immer direkt auf der Plattform und sehen Sie sich unseren Coupon-Guide für die neuesten Informationen an.",
  "faq.q7": "Wie funktioniert das CSSBuy-Warehouse?",
  "faq.a7": "Das CSSBuy-Warehouse empfängt Ihre Bestellungen von Verkäufern, lagert sie, führt Qualitätskontrollen (QC) durch und bereitet Pakete für den internationalen Versand vor. Sie können Fotos anfordern, mehrere Artikel kombinieren und Versandmethoden aus dem Warehouse wählen.",
  "faq.q8": "Können Anfänger CSSBuy nutzen?",
  "faq.a8": "Ja, Anfänger können CSSBuy nutzen, aber es gibt eine Lernkurve. Wir empfehlen, mit unserem Anfänger-Guide zu beginnen, zu verstehen, wie Warehouse und QC-Prozess funktionieren, und kleine Testbestellungen vor größeren Käufen zu tätigen.",

  "newsletter.title": "Bleiben Sie auf dem Laufenden",
  "newsletter.subtitle": "Erhalten Sie die neuesten CSSBuy Spreadsheet-Updates, Produktfunde und Einkaufs-Guides direkt in Ihren Posteingang.",
  "newsletter.placeholder": "E-Mail-Adresse eingeben",
  "newsletter.button": "Abonnieren",
  "newsletter.privacy": "Wir respektieren Ihre Privatsphäre. Jederzeit abbestellen.",
  "newsletter.success": "Vielen Dank für Ihre Anmeldung!",
  "newsletter.error": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",

  "cta.main.title": "Bereit, Ihr nächstes Produkt zu finden?",
  "cta.main.subtitle": "Erkunden Sie unsere CSSBuy Spreadsheet, finden Sie Produkte und lesen Sie unsere Haupt-Guides, bevor Sie Ihre Reise fortsetzen.",
  "cta.main.primary": "CSSBuy Spreadsheet erkunden",
  "cta.main.secondary": "Hauptwebsite besuchen",

  "footer.spreadsheet": "CSSBuy Spreadsheet",
  "footer.desc": "Ein unabhängiger Ressourcen-Hub für CSSBuy-Benutzer. Nicht mit CSSBuy verbunden oder von CSSBuy unterstützt.",
  "footer.links.title": "Schnelllinks",
  "footer.links.spreadsheet": "Spreadsheet",
  "footer.links.finds": "Finds",
  "footer.links.review": "Review",
  "footer.links.shipping": "Versand",
  "footer.links.coupon": "Coupons",
  "footer.links.safety": "Sicherheit",
  "footer.links.blog": "Blog",
  "footer.resources.title": "Ressourcen",
  "footer.resources.guides": "Einkaufs-Guides",
  "footer.resources.qc": "QC-Guide",
  "footer.resources.sellers": "Verkäufer-Guide",
  "footer.resources.comparisons": "Vergleiche",
  "footer.legal.title": "Rechtliches",
  "footer.legal.about": "Über uns",
  "footer.legal.policy": "Redaktionsrichtlinien",
  "footer.legal.contact": "Kontakt",
  "footer.disclaimer": "Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden oder von CSSBuy unterstützt.",
  "footer.copyright": "© 2026 CSSBuy Spreadsheet. Alle Rechte vorbehalten.",

  "lang.en": "English",
  "lang.pt": "Português",
  "lang.de": "Deutsch",

  "dropdown.label": "Alle Kategorien",
  "dropdown.placeholder": "Kategorie wählen...",

  "disclaimer": "Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden oder von CSSBuy unterstützt.",

  "article.published": "Veröffentlicht",
  "article.updated": "Aktualisiert",
  "article.readingTime": "Min. Lesezeit",
  "article.author": "Redaktionsteam",
  "article.sources": "Quellen",
  "article.cta": "CSSBuy Spreadsheet erkunden",
  "article.ctaSecondary": "Hauptwebsite besuchen",
  "article.related": "Verwandte Artikel",
  "article.breadcrumb.home": "Startseite",
  "article.breadcrumb.blog": "Blog",
  "article.tableOfContents": "Inhaltsverzeichnis",
  "article.share": "Diesen Artikel teilen",
  "article.reportError": "Fehler melden",
  "article.lastReviewed": "Zuletzt geprüft"
};